<template>
  <div id="app">
    <!-- 头部组件 -->
    <div class="header">
      <div class="headerbox">
        <div>
          <img class="topImg" src="@/assets/imgs/toplogo-sign.png" alt />
        </div>
        <a class="link" href=""
          >2022年秋季双选会西安场报名火热进行中，详情点击 →</a
        >
        <div class="rightBox">
          <el-dropdown trigger="click" @command="handleOpenDialog">
            <img
              class="userImg"
              v-if="avatar"
              :src="avatar"
              :onerror="defaultAvatarImgae"
              alt
            />
            <img class="userImg" v-else src="../../assets/imgs/hello.png" alt />
            <span class="el-dropdown-link tophelp">
              {{ nickname }}
            </span>
            <el-dropdown-menu slot="dropdown" class="downlist">
              <el-dropdown-item command="0">联系客服</el-dropdown-item>
              <el-dropdown-item>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <!-- <div style="display: flex;align-items: center;height: 85px;background: #F5F7FD;border: 1px solid #DEDEDE;padding: 30px 44px;">
      <div style="position: relative;height: 85px;width: 64px;display: flex;flex-direction: column;justify-content: space-between;align-items: center;">
        <img
          style="display:flex;justify-content:center;align-items:center;width: 56px; height: 56px; border-radius: 28px;"
          src=""
          onerror=""
        />
        <img style="position: absolute;right: 0;top: 0;" src="" />
        <span style="width: 64px;line-height: 19px;background: #0077FF;border-radius: 11px; font-size:12px; color:#fff;text-align: center;">20k-20k</span>
      </div>
      <div style="margin-left:20px;height: 78px;display: flex;flex-direction: column;justify-content: space-between;align-items: end;">
        <p>
          <span style="font-size: 16px;font-family: MicrosoftYaHeiSemibold;color: #333333;">
            姚先生
          </span>
          <span style="font-size: 12px;font-family:MicrosoftYaHei;color: #333333;margin-left:20px;">
            13888888888
          </span>
          <span style="background: #0077ff; padding: 0 3px;margin-left: 15px;text-align: center;font-size: 12px;color: #fff;">
            社招
          </span>
        </p>
        <p style="font-size: 14px;font-family: MicrosoftYaHei;color: #333333;text-align: left;">
          芯片设计工程师
          <span style="margin-left:30px;">博通集成电路（上海）股份有限公司</span>
        </p>
        <p
          style="font-size: 12px;font-family: MicrosoftYaHei;color: #666666;text-align: left;"
        >
          <span>本科</span>
          <span style="margin-left:5px;">北京信息科技大学</span>
          <span style="margin-left:5px;">计算机科学技术</span>
        </p>
      </div>
    </div> -->
    <section>
      <h5>“疫往无前 职通未来”爱集微大型公益活动之全国校招护航行报名表</h5>
      <span></span>
      <img src="@/assets/imgs/toplogo-sign.png" />
      <p>
        疫情来袭，为帮助毕业生就业。爱集微职场打造全公益性质的线上招聘平台，联动10省市60余所高校开启「疫往无前
        职通未来」爱集微全国校招护航行动。
      </p>
      <p>
        由中国半导体联盟、爱集微与各地集成电路协会联合打造，本次公益行动计划将于4月29日前密集触达上海、西安、江苏、安徽、重庆、成都、武汉、广州、深圳、北京、福建、浙江全国12省60余所高校学子。
      </p>
      <p>
        欢迎广大ICT企业踊跃报名，数量有限，先到先得，本次公益活动企业最多可报名6所城市的线上春招。
      </p>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        label-position="left"
        class="demo-ruleForm"
      >
        <el-form-item label="活动名称:" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="企业简称:" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="联系人姓名:" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="职位:" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="邮箱:" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="招聘人数需求:" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="所在城市:" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item class="btn">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </section>
    <!-- 联系客服弹窗 -->
    <div class="onebox">
      <el-dialog
        title="联系客服"
        :visible.sync="isShowContact"
        width="22%"
        center
        style="border-radius: 8px"
        class="showBox"
      >
        <div class="contactBox">
          <div class="leftimg">
            <img src="@/assets/imgs/hello.png" alt />
          </div>
          <div class="rightText">
            <p>客服电话 : 13524808972</p>
            <p>如您在使用过程中遇到任何问题，请联系我们的工作人员。</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer contactFooter">
          <el-button type="primary" @click="isShowContact = false"
            >知道了</el-button
          >
        </span>
      </el-dialog>
    </div>
    <div class="footer">
      <p>
        Copyright 2007-{{ currentYear }}©LaoYaoBa.com™Inc.All rights reserved |
        闽ICP备17032949号-2
      </p>
      <p>闽公网安备 35020502000344号</p>
    </div>
  </div>
</template>
<script>
import PublicApi from "@/api/PublicModule";
import { removeToken, removeTime } from "@/utils/auth";
export default {
  data() {
    return {
      defaultAvatarImgae:
        'this.src="' + require("../../assets/imgs/hello.png") + '"',
      avatar: "",
      // 联系客服弹窗是否显示
      isShowContact: false,
      // 意见反馈弹窗是否显示
      isShowFeedback: false,
      // 意见反馈内容
      FeedbackBoxText: "",
      nickname: "",
      currentYear: "",
      ruleForm: {
          name: '',

        },
        rules: {
          name: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
            { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],

        }
    };
  },
  methods: {
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    handleOpenDialog(e) {
      if (e === "0") {
        this.isShowContact = true;
        this.isShowFeedback = false;
      } else if (e === "1") {
        this.isShowContact = false;
        this.isShowFeedback = true;
        this.FeedbackBoxText = "";
      } else {
        removeToken();
        removeTime();
        localStorage.setItem("isLogin", "2");
        localStorage.removeItem("account");
        this.$router.push({
          path: "/login",
        });
      }
    },
    account() {
      var that = this;
      var account = JSON.parse(localStorage.getItem("account")) || {};
      that.nickname = account.nickname;
      that.avatar = account.avatar;
    },
  },
  mounted() {},
  created() {
    this.account();
    let date = new Date();
    this.currentYear = date.getFullYear();
  },
};
</script>
<style scoped>
.link {
  line-height: 50px;
  font-size: 12px;
  color: #fff;
}
section {
  width: 720px;
  min-height: 20px;
  background: #fff;
  border-radius: 5px;
  margin: 20px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 44px 0 69px;
}
section h5 {
  width: 547px;
  font-size: 20px;
  font-family: MicrosoftYaHeiSemibold;
  color: #333333;
  text-align: center;
}
section span {
  width: 508px;
  height: 1px;
  background: #f5f6f9;
  margin-top: 30px;
}
section img {
  width: 508px;
  height: 212px;
  margin-top: 23px;
}
section p {
  width: 508px;
  margin-top: 25px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #333333;
  line-height: 20px;
}
.demo-ruleForm{
  width: 508px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
}
.demo-ruleForm /deep/ .el-form-item__label{
  padding: 0;
}
.demo-ruleForm .el-input{
  width: 340px;
}
.demo-ruleForm /deep/ .el-button{
  width: 100%;
}
.demo-ruleForm .btn{
  width: 100%;
  margin-top: 23px;
}
.demo-ruleForm .btn /deep/ .el-form-item__content{
  margin: 0 !important;
}
.header {
  width: 100%;
  min-width: 1280px;
  height: 50px;
  background: #003068;
}
.headerbox {
  width: 1280px;
  height: 100%;
  min-width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
}
.headerbox .topImg {
  width: 94px;
  height: 22px;
  margin-top: 14px;
}
.headerbox .topusername {
  line-height: 50px;
  font-size: 12px;
  color: #666666;
  cursor: pointer;
}
.headerbox .userImg {
  display: inline-block;
  width: 24px;
  height: 24px;
  vertical-align: middle;
  border-radius: 50%;
}
.header .tophelp {
  line-height: 50px;
  font-size: 12px;
  color: #fff;
}

.footer {
  width: 100%;
  height: 150px;
  bottom: -100px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  padding: 19px 0 0 0;
  box-sizing: border-box;
}
.footer p {
  font-size: 12px;
  color: #333;
  line-height: 16px;
}
</style>
<style>
.onebox .el-dialog--center {
  min-width: 453px;
}
.el-dropdown-menu__item {
  font-size: 12px;
}
.showBox .el-dialog__body {
  padding-bottom: 0 !important;
}
.el-dialog__footer {
  padding-bottom: 30px;
  padding-top: 40px;
}
.contactFooter .el-button {
  width: 116px;
  height: 35px;
  border-radius: 4px;
  line-height: 0;
}
.Feedbackfooter .el-button {
  width: 90px;
  height: 35px;
  border-radius: 4px;
  line-height: 0;
}
.el-dialog__header {
  border-bottom: 1px solid #f5f6f9;
  padding: 15px 0 12px;
}
.el-icon--right {
  margin-left: 0 !important;
  transition: transform 0.3s, -webkit-transform 0.3s;
}

</style>



// WEBPACK FOOTER //
// src/views/signUp/index.vue